import { defineComponent as _defineComponent } from 'vue';
import DataTable from 'primevue/datatable';
import { getCurrentInstance } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataTable',
    setup(__props, { expose }) {
        expose();
        const primevueDataTableDefaults = getCurrentInstance()?.appContext.config.globalProperties
            .primevueDataTableDefaults;
        const __returned__ = { primevueDataTableDefaults, get DataTable() { return DataTable; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
